module.exports = __webpack_public_path__ + "ad861afc6482363e4a8f41b0b3584288.MP3";